import React from "react";
import { useLocation } from "react-router-dom";
import { IMenuViewModel } from "../../model/response/auth/IMenuViewModel";
import { hasRoutePermission } from "../../content/routers";
import { Box, Heading, Text } from "@primer/react";
import { ShieldLockIcon } from "@primer/octicons-react";

interface IProtectedRouteProps {
  children: React.ReactNode;
  userMenus: IMenuViewModel[];
}

const UnauthorizedPage: React.FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="80vh"
      p={4}
    >
      <Box mb={4}>
        <ShieldLockIcon size={64} fill="#d1242f" />
      </Box>
      
      <Heading as="h1" sx={{ fontSize: 3, mb: 2, color: "danger.fg" }}>
        Không có quyền truy cập
      </Heading>
      
      <Text sx={{ fontSize: 1, color: "fg.muted", textAlign: "center", mb: 4, maxWidth: "400px" }}>
        Bạn không có quyền truy cập vào trang này. Vui lòng liên hệ quản trị viên để được cấp quyền.
      </Text>
    </Box>
  );
};

const ProtectedRoute: React.FC<IProtectedRouteProps> = ({ 
  children, 
  userMenus
}) => {
  const location = useLocation();
  const currentPath = location.pathname;

  // Check if user has permission to access current route
  const hasPermission = hasRoutePermission(currentPath, userMenus);

  if (!hasPermission) {
    return <UnauthorizedPage />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;